// Common utilities
export const formatDate = (date: Date): string => {
  return date.toISOString();
};

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const generateId = (): string => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

// Export logger
export { logger, type LoggerInterface, type LogContext } from './logger';

// Export country utilities
export {
  getCountryName,
  getCountryCode,
  getCountryCodeAlpha3,
  getCountryCurrency,
  isValidCountryCode,
  getSupportedCountryCodes,
  getCountryOptions,
} from './country.utils';

// Export UUID utilities
export { generateUUID } from './uuid.utils';

// Export CSV utilities
export { escapeCsvValue, toCsvRow, generateCsv } from './csv.utils';

// Export geo utilities
export {
  toRadians,
  toDegrees,
  calculateDistance,
  calculateRouteDistance,
  calculateCenterPoint,
  calculateBoundingBox,
  isWithinBoundingBox,
  estimateDrivingDistance,
  estimateDrivingTime,
  calculateBearing,
  calculateDestinationPoint,
  isPointInPolygon,
  isPointInCircle,
} from './geo.utils';

// Export ABC classification utilities
export {
  calculateABCClassification,
  getABCClassificationDescription,
  getABCClassificationColor,
} from './abc-classification.util';

// Export checksum utilities
export { validateChecksum, calculateMod10CheckDigit } from './checksum.util';

// Export identifier validation utilities
export { validateIdentifier, isValidRegexPattern } from './identifier-validator.util';

// Export numeric transformer for TypeORM decimal columns
export { numericTransformer } from './column-numeric.transformer';

// Export LLM text-parsing utilities (shared by ai-chatbot + agent-core)
export {
  extractFirstJsonRegion,
  parseLLMJson,
  stripMarkdownFences,
  stripThinkingTags,
  ThinkingTagStreamFilter,
  type TypeGuard,
} from './llm-text.utils';

// Phone normalization (digit-strip preprocess + canonical regex)
// Used in form schemas as `z.preprocess(stripNonDigits, z.string().regex(PHONE_DIGITS_REGEX))`.
export { stripNonDigits, normalizePhoneToDigits, PHONE_DIGITS_REGEX } from './normalize-phone.util';

// US SSN validation — format + SSA range rules. Mirrors backend
// `usa-driver.regulations.ts` so the client can pre-empt the 400 toast.
export { validateSsn, type SsnValidationCode, type SsnValidationResult } from './ssn.util';
